export default __webpack_public_path__ + "static/media/plus.168c6ecc.svg";